define('home/templates/channelLeadersEmpty',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"text-center text-gray padding-double\">"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.message : depth0), depth0))
    + "</div>\n";
},"useData":true})

});
